// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eruda-dev-tools .eruda-tools .eruda-monitor{padding:10px;overflow-y:auto;-webkit-overflow-scrolling:touch}.eruda-dev-tools .eruda-tools .eruda-monitor .eruda-memory,.eruda-dev-tools .eruda-tools .eruda-monitor .eruda-dom-nodes{margin:10px 0}.eruda-dev-tools .eruda-tools .eruda-monitor .luna-performance-monitor{border-color:var(--border) !important}", ""]);
// Exports
module.exports = exports;
